<template>
  <div>
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="입고 내역 조회"
      ref="admin_filter"
    ></admin-filter>
    <div class="columns is-multiline">
      <div class="column is-full">
        <div class="flex-between">
          <button class="button is-primary" @click="checkedDelete">선택 삭제</button>
          <div class="flex-end" style="gap:8px">
            <button class="button is-gray btn-download" @click="clickDownload">
              <i class="material-icons">cloud_download</i>Excel 다운로드</button>
            <button class="button is-primary" @click="clickCreate">화물 입고</button>
          </div>
        </div>
      </div>
      <div class="column is-full">
        <admin-table :field_list="tableData"
                     :items="tableItems"
                     :filtered="filtered"
                     :allCount="allCount"
                     :filteredCount="filteredCount"
                     :table_width="2000"
                     @check="clickCheckBox"
                     @getData="getDataFromServer"
                     @ordering="ordering"
                     @selPageLength="selPageLength">
          <div slot="checkspot" slot-scope="props">
            <lp-check-bool
              v-if="showcaseCheckArr[props.idx]!==undefined"
              :checkedVal.sync="showcaseCheckArr[props.idx].value"></lp-check-bool>
          </div>
          <div slot="receipt_time" slot-scope="props">{{ datesFormat(props.item.receipt_time, 'date_4') }}</div>
          <div slot="reference_no" slot-scope="props">
            <router-link v-if="props.item.order" :to="`/office/admin/ship_agency/order_detail?id=${props.item.order}`"
              style="text-decoration: underline">
              {{ props.item.reference_no }}
            </router-link>
            <template v-else>{{ props.item.reference_no }}</template>
          </div>
          <div slot="memo" slot-scope="props" style="white-space: pre-wrap">{{ props.item.memo }}</div>
          <div slot="modify_delete" slot-scope="props">
            <button class="button half"
                    @click.stop.prevent="updateItem(props.item)" style="margin-right:4px">수정</button>
            <button class="button half is-danger" @click.stop.prevent="deleteItem(props.item)">삭제</button>
          </div>
        </admin-table>
      </div>
    </div>
    <receipts-modal ref="modal" @save="getDataFromServer"></receipts-modal>
  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'
  import LpCheckBool from "../../module/common/LpCheckBool";
  import AdminTable from "../../module/admin/AdminTable";
  import AdminFilter from "../../module/admin/AdminFilter";
  import ReceiptsModal from "./components/ReceiptsModal";

  export default {
    name: "Receipts",
    components: {ReceiptsModal, AdminFilter, AdminTable, LpCheckBool},
    mixins: [
      ListMixin
    ],
    created() {
      this.init();
    },
    data() {
      return {}
    },
    methods: {
      init() {
        this.initializing('receipts', `shipagency/${this.$route.path.indexOf('france')>-1 ? 'fr' : 'de'}/receipts`);
      },
      getDataFromServer() {
        this.showcaseCheckArr.forEach(i => {
          i.value = false;
        });
        this.getData();
      },
      clickCreate() {
        this.$refs.modal.open();
      },
      clickDownload() {
        let ids = this.getCheckedArr();
        let params = this.cloneItem(this.filtered);
        if(ids.length>0) {
          params.ids = ids.toString();
        }
        this.$axios.get('admin/shipagency/receipts/download', {
          responseType: 'arraybuffer',
          params: params
        }).then(res => {
          const blob = new Blob([res.data], {type: `application/xls`});
          const blobURL = window.URL.createObjectURL(blob);
          const tempLink = document.createElement('a');
          tempLink.style.display = 'none';
          tempLink.href = blobURL;
          tempLink.setAttribute('download', `receipts_${this.moment().format('YYYYMMDDHHmm')}.xls`);
          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          window.URL.revokeObjectURL(blobURL);
        });
      },
      checkedDelete() {
        let ids = this.getCheckedArr();
        if(ids.length === 0) {
          this.toast('삭제할 항목을 선택해주세요');
        } else {
          if(confirm('선택한 항목을 삭제하시겠습니까?')) {
            this.$axios.post('admin/shipagency/receipts/delete/multiple', {ids: ids}).then(res => {
              if(res.status === 200) {
                this.getDataFromServer();
              }
            });
          }
        }
      },
      updateItem(item) {
        this.$refs.modal.open(item);
      },
      deleteItem(item) {
        if(confirm('항목을 삭제하시겠습니까?')) {
          this.$axios.delete(`admin/shipagency/receipts/${item.id}`).then(res => {
            if(res.status === 200) {
              this.getDataFromServer();
            }
          });
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .btn-download
    width fit-content
    display flex
    align-items center
    gap 8px
</style>
